/**
 * Patch the canvas.getContext() method to force WebGL contexts to use
 * preserveDrawingBuffer: true.
 *
 * This is specifically required for the Screenshot functionality, where we
 * need to capture all visual layers rendered by Sigma.js, including WebGL
 * canvases (e.g., nodes and edges).
 *
 * Without preserveDrawingBuffer: true, the WebGL canvas contents may be
 * cleared after each frame, resulting in blank or incomplete screenshots.
 *
 * Our current version of Sigma.js v2.4.0 does not support setting preserveDrawingBuffer directly.
 * This patch is a workaround until upgrading to Sigma v2.5.0, which adds
 * official support.
 */

export function patchWebGLContext() {
  const original = HTMLCanvasElement.prototype.getContext;

  HTMLCanvasElement.prototype.getContext = function (
    this: HTMLCanvasElement,
    type: string,
    attributes?: any
  ): any {
    if (type === "webgl" || type === "webgl2") {
      const patchedAttrs = {...(attributes || {}), preserveDrawingBuffer: true};
      return original.call(this, type, patchedAttrs);
    }

    return original.call(this, type, attributes);
  };
}
